export var Environment;
(function (Environment) {
    Environment["LIVE"] = "LIVE";
    Environment["SANDBOX"] = "SANDBOX";
    Environment["SANDBOX_PREFERRED"] = "SANDBOX_PREFERRED";
})(Environment || (Environment = {}));
export var ACTION;
(function (ACTION) {
    ACTION["UNKNOWN_ACTION"] = "UNKNOWN_ACTION";
    ACTION["SET_FIELD"] = "SET_FIELD";
    ACTION["REMOVE_FIELD"] = "REMOVE_FIELD";
    ACTION["INCREMENT_FIELD"] = "INCREMENT_FIELD";
    ACTION["APPEND_TO_ARRAY"] = "APPEND_TO_ARRAY";
    ACTION["REMOVE_FROM_ARRAY"] = "REMOVE_FROM_ARRAY";
})(ACTION || (ACTION = {}));
export var BulkActionType;
(function (BulkActionType) {
    BulkActionType["UNKNOWN_ACTION_TYPE"] = "UNKNOWN_ACTION_TYPE";
    BulkActionType["INSERT"] = "INSERT";
    BulkActionType["UPDATE"] = "UPDATE";
    BulkActionType["DELETE"] = "DELETE";
    BulkActionType["PATCH"] = "PATCH";
})(BulkActionType || (BulkActionType = {}));
export var Action;
(function (Action) {
    Action["UNKNOWN_ACTION"] = "UNKNOWN_ACTION";
    Action["INSERTED"] = "INSERTED";
    Action["UPDATED"] = "UPDATED";
})(Action || (Action = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var Mode;
(function (Mode) {
    /** Any of the search terms must be present. */
    Mode["OR"] = "OR";
    /** All search terms must be present. */
    Mode["AND"] = "AND";
})(Mode || (Mode = {}));
//# sourceMappingURL=data-item-types.js.map